import { useCallback } from 'react';

import { Trash } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

import ConfirmationPopover from '@/components/ConfirmationPopover';
import { APP_PREFIX } from '@/utils/constants';
import { useAppAlert } from '@Components/AppAlert';
import DeleteConfirmationContent from '@Components/DeleteConfirmationContent';
import { useGrid } from '@Components/Grid';
import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function DeleteEntryWithReferences({ info }) {
  const { row } = getInfo(info)
  const { definitions: { entityName }, events: { handleDeleteEntry }, store: { references: { useLoad: getReferences } } } = useGrid()
  const { handleSuccess } = useAppAlert()

  const handleSubmit = useCallback(async () => {
    await handleDeleteEntry(row)
    handleSuccess(`${entityName} deleted!`)
  }, [row, handleDeleteEntry, handleSuccess, entityName])

  const loadReferences = useCallback(async () => {
    const data = await getReferences(row.id)
    const references = {}

    const allocations = data?.allocations?.map(({ id, description, default: isDefault, site_id }) => {
      const url = `${APP_PREFIX}/offer/allocations/${id}`
      return { id, description, url, default: isDefault, site_id }
    })

    const posts = data?.posts?.map(({ id, title, content_type, default: isDefault, site_id }) => {
      const url = `${APP_PREFIX}/cms/${content_type}/${id}`
      return { id, description: title, url, default: isDefault, site_id }
    })

    if (allocations?.length) {
      references.allocations = allocations
    }

    if (posts?.length) {
      references.posts = posts
    }

    return references
  }, [row, getReferences])

  return <>
    <ConfirmationPopover
      target={<DefaultTooltip content='Delete' side='left'><Trash size={16} /></DefaultTooltip>}
      title={<span>Delete {entityName.toLowerCase()} <i>{`[#${row.id}] ${row.name || row.description}`}</i></span>}
    >
      <DeleteConfirmationContent origin="form" loadReferences={loadReferences} action={handleSubmit} />
    </ConfirmationPopover>
  </>
}
